module.exports = ".row{\r\npadding:20px 0px 10px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/company/company-form/company-form.component.css
// module id = ./src/app/masters/company/company-form/company-form.component.css
// module chunks = main